import Keycloak from 'keycloak-js';

const url = `${window.location.origin}/auth`
const realm = window.location.hostname.split('.')[0]; 
const clientId = `${realm}-client`
const keycloak = new Keycloak({
  url: url,
  realm: realm,
  clientId: clientId,
});

export default keycloak;